'use client'

import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

import Disclosure from './Disclosure'
import StepLabel, { emphasiseVerb } from './StepLabel'

type ThoughtRowProps = {
  text: string
}

/** One finished reasoning part as a collapsed "Thought" row that opens to the model's summarized thinking. */
export default function ThoughtRow({ text }: ThoughtRowProps) {
  const t = useTranslations('features.AssistantV2')
  const trimmed = text.trim()
  if (!trimmed) return null

  return (
    <Disclosure label={<StepLabel>{t.rich('thought', { verb: emphasiseVerb })}</StepLabel>}>
      <Typography
        variant="body2"
        component="p"
        data-testid="assistant-reasoning"
        sx={{ m: 0, color: 'text.secondary', whiteSpace: 'pre-wrap' }}
      >
        {trimmed}
      </Typography>
    </Disclosure>
  )
}
